import { CButton, CForm, CFormText } from "@coreui/react";
import React, { useEffect, useState } from "react";
import ToastMessage from "src/_components/ToastMessage";
import {
  AlertResponse,
  addToastError,
  addToastSuccess,
} from "src/_constants/alert.type";
import Auth from "src/auth";
import { useHistory, useParams } from "react-router-dom";
import {
  AnchorLinkSet,
  AnchorLinkSetOnClick,
  CommanPageLoader,
  ControlFileUpload,
  ControlInputValidationText,
  ControlSelectValidation,
  ControlTextAreaValidationText,
  DetailChecbox,
  DetailLabel,
  DetailLabelBind,
  DetailRow,
  DetailRowOnly,
  DetailSectionBind,
  isValidDate,
  requiredValid,
} from "src/views/common/Common";
import {
  apiCallResponse,
  apiCallResponsePost,
  apiCallSP,
  apiCallSPPost,
} from "src/_apiConfig/apiCall";
import { valueSet } from "./AdHocPaymentCommon";
import { AmountValidationFloat } from "src/views/common/commonValidation";
import { updateSearchStatus } from "src/views/common/CommonSearch";

const AdHocPaymentEdit = () => {
  let history = useHistory();
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pData, setPData] = useState();
  const [loading, setloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false); // submit loading

  let { AdHocPaymentId } = useParams();
  const decrypted = window.atob(AdHocPaymentId);

  const [toasts, setToasts] = useState(AlertResponse);

  //const [search, setSearch] = useState(SearchFilterModel);
  const [isIGST, setIsIGST] = useState(false);
  const [selectedOption, setSelectedOption] = useState(0);

  const params = {
    tenderId: "",
    lotId: 0,
    amount: "",
    paymentTypeId: 0,
    dueDate: "",
    cgstAmount: "",
    sgstAmount: "",
    igstAmount: "",
    title_purposes_option: "",
    title_purposes: "",
    created_comment: "",
    totalAmount: 0,
    checker_comment: "",
    checker_date: "",
    checker_by_name: "",
  };

  const [addParam, setAddParam] = useState(params);

  const [formState, setFromState] = useState({
    amount: { errors: "", valid: true },
    paymentTypeId: { errors: "", valid: true },
    dueDate: { errors: "", valid: true },
    cgstAmount: { errors: "", valid: true },
    sgstAmount: { errors: "", valid: true },
    igstAmount: { errors: "", valid: true },
    title_purposes_option: { errors: "", valid: true },
    title_purposes: { errors: "", valid: true },
    created_comment: { errors: "", valid: true },
    support_document: { errors: "", valid: true },
  });

  const [DocumentSelectedFile, setDocumentSelectedFile] = useState();
  const [DocumentFileEvent, setDocumentFileEvent] = useState(false);

  const TitlePurposesOption = [
    { value: "Godown Rent", label: "Godown Rent" },
    { value: "GST", label: "GST" },
    { value: "Income Tax", label: "Income Tax" },
    { value: "Late Fees", label: "Late Fees" },
    { value: "Installment", label: "Installment" },
    { value: "Others", label: "Others" },
  ];

  useEffect(() => {
    setloading(true);
    getData(authenticated.userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const calculateTotalAmount = (gD) => {
    let totalAmount =
      gD?.amount && parseFloat(gD?.amount) > 0 ? parseFloat(gD?.amount) : 0;

    totalAmount +=
      gD?.cgstAmount && parseFloat(gD?.cgstAmount) > 0
        ? parseFloat(gD?.cgstAmount)
        : 0;
    totalAmount +=
      gD?.sgstAmount && parseFloat(gD?.sgstAmount) > 0
        ? parseFloat(gD?.sgstAmount)
        : 0;
    totalAmount +=
      gD?.igstAmount && parseFloat(gD?.igstAmount) > 0
        ? parseFloat(gD?.igstAmount)
        : 0;

    return totalAmount;
  };

  const getTitlePurpose = (value) => {
    // Check if the value exists in the options
    const match = TitlePurposesOption.find((option) => option.value === value);
    // If a match is found, return the label; otherwise, return "Others"
    return match ? match.value : "Others";
  };
  const getData = async () => {
    const user_Type =
      authenticated.role === "CGMF" ? 1 : authenticated.role === "DFO" ? 2 : 0;

    if (authenticated) {
      setloading(true);
      setUsersData();
      await apiCallSP(
        `LotAdHocPayment/getDetailByAdHocPaymentId?AdHocPaymentId=${decrypted}&User_type=${user_Type}&User_id=${authenticated.userId}`
      ).then((res) => {
        if (res.success) {
          setUsersData(res.data);
          const getData = res.data;
          setSelectedOption(getData.paymentTypeId.toString());
          console.log("dd getData 22", getData);

          let gTA = calculateTotalAmount(getData);

          let gettitle_Purpose_Option = getTitlePurpose(getData.title_Purpose);

          setAddParam({
            ...addParam,
            tenderId: getData.tenderId,
            lotId: getData.lotId,
            amount: getData.amount,
            paymentTypeId: getData.paymentTypeId,
            dueDate: getData.dueDate,
            cgstAmount: getData.cgstAmount,
            sgstAmount: getData.sgstAmount,
            igstAmount: getData.igstAmount,
            title_purposes_option: gettitle_Purpose_Option,
            title_purposes: getData.title_Purpose,
            created_comment: getData.insertedComment,
            totalAmount: gTA,
            checker_comment: getData.checkerComment,
            checker_date: getData.checkerDate,
            checker_by_name: getData.checkerByName,
          });

          getDataPurchaser(
            getData.collectionSeason,
            getData.tenderId,
            getData.lotId
          );
        } else {
          setloading(false);
        }
      });
    }
  };

  const getDataPurchaser = async (collectionSeason, tenderId, lotId) => {
    if (authenticated) {
      setloading(true);
      setPData();

      if (
        Number(collectionSeason) > 0 &&
        Number(tenderId) > 0 &&
        Number(lotId) > 0
      ) {
        const data = JSON.stringify({
          tender_id: Number(tenderId),
          lot_id: Number(lotId),
          collection_season: Number(collectionSeason),
        });
        await apiCallSPPost("LotAdHocPayment/BidderDetailByLotId", data, [])
          .then((res) => {
            if (res.success && res.totalRecord > 0) {
              //alert("callllll");
              setPData(res.data);
            }
          })
          .finally(() => {
            setloading(false);
          });
      } else {
        setPData();
        setloading(false);
      }
    }
  };

  const LotDetail = (
    <>
      <DetailLabelBind
        lable="Collection Season"
        value={valueSet(usersData?.collectionSeason)}
      />
      <DetailLabelBind
        lable="Tender No."
        value={valueSet(usersData?.tenderNo)}
      />
      <DetailLabelBind lable="Lot No." value={valueSet(usersData?.lotNo)} />
      {/* <DetailLabelBind
                      lable="Purchaser Name"
                      value={valueSet(usersData?.purchaserName)}
                    /> */}
    </>
  );

  const BidderDetails = (
    <>
      <DetailLabelBind
        lable="Email Address"
        value={pData?.emailId && pData?.emailId}
      />
      <DetailLabelBind
        lable="Goods and Services"
        value={pData?.gst && pData?.gst}
      />
      <DetailLabelBind
        lable="Propritor Name"
        value={pData?.username && pData?.username}
      />
      <DetailLabelBind
        lable="Company Name"
        value={pData?.companyName && pData?.companyName}
      />
      <DetailLabelBind lable="Mobile" value={pData?.mobile && pData?.mobile} />
      <DetailLabelBind
        lable="Name of Forest Division Where Tenderer Registered"
        value={pData?.registeredDistrict && pData?.registeredDistrict}
      />
    </>
  );

  const handleChangeSupportingDocument = (e) => {
    setDocumentFileEvent(e);
    setDocumentSelectedFile(e.target.files[0]);
    const errors = [];
    let fileEvent = e;
    if (
      !fileEvent ||
      !fileEvent.target ||
      !fileEvent.target.files ||
      fileEvent.target.files.length === 0
    ) {
      errors.push("Please Upload Supporting Document file!");
      UpdateErrorArray(
        "support_document",
        errors.length > 0 ? errors : "",
        true
      );
      return;
    }

    const file = fileEvent.target.files[0];
    if (file.type !== "application/pdf") {
      errors.push("Please Upload Only PDF file!");
    } else if (file.size > 2 * 1024 * 1024) {
      // 2MB in bytes
      errors.push("File size exceeds 2MB. Please upload a smaller file.");
    }

    UpdateErrorArray("support_document", errors.length > 0 ? errors : "", true);

    e.preventDefault();
  };
  const handleChangeTitlePurposesOption = (e) => {
    const value = e.target.value;
    updateParam(e, "title_purposes_option", value);
    if (value === "" || value !== "Others") {
      updateParam(e, "title_purposes", value);
    }
    if (value === "Others") {
      updateParam(e, "title_purposes", "");
    }
    const errors = [];
    if ((!value && value.length === 0) || value.trim() === "") {
      errors.push("Please select Title/Purpose");
    }
    UpdateErrorArray(
      "title_purposes_option",
      errors.length > 0 ? errors : "",
      true
    );

    e.preventDefault();
  };

  // validate Required Feild
  const handleChangesManually = (name, value, isValidate = false, msg = "") => {
    //console.clear(); // type like textbox,check box,name=control name

    setAddParam((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (isValidate) {
      let validResp = requiredValid(value, msg);
      //console.log(validResp)
      //   if (!validResp.isValid) {
      //     e.target.focus();
      //   }
      let FromStateJson = formState[name];
      FromStateJson.valid = validResp.isValid;
      FromStateJson.errors = validResp.Message;
      setFromState((prevState) => ({
        ...prevState,
        [name]: FromStateJson,
      }));
    }
    //console.log(formState)
  };

  // validate Required Feild
  const handleChanges = (e, isValidate = false, msg = "") => {
    //console.clear(); // type like textbox,check box,name=control name

    setAddParam((prevState) => ({
      ...prevState,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    }));
    if (isValidate) {
      let validResp = requiredValid(e.target.value, msg);
      //console.log(validResp)
      if (!validResp.isValid) {
        e.target.focus();
      }
      let FromStateJson = formState[e.target.name];
      FromStateJson.valid = validResp.isValid;
      FromStateJson.errors = validResp.Message;
      setFromState((prevState) => ({
        ...prevState,
        [e.target.name]: FromStateJson,
      }));
    }
    //console.log(formState)
  };

  // Search Model Value Update Manage
  const updateParam = (e, name = "", value = "") => {
    updateSearchStatus(setAddParam, addParam, e, name, value);
  };

  const calculatePercentage = (total, percentage) => {
    return (percentage / 100) * total;
  };

  const handlePaymentChange = (event) => {
    onResetData();
    event.preventDefault();
    setSelectedOption(event.target.value);
    updateParam(event);
    handleChanges(event, true, "Please Select Payment Option");

    if (selectedOption != event.target.value) {
      setAddParam({
        ...addParam,

        amount: "",
        paymentTypeId: event.target.value,
        dueDate: "",
        cgstAmount: "",
        sgstAmount: "",
        igstAmount: "",
        title_purposes_option: "",
        title_purposes: "",
        created_comment: "",
        totalAmount: 0,
        checker_comment: "",
        checker_date: "",
        checker_by_name: "",
      });
    }
  };

  // Function to handle date changes
  const handleDateValidation = (event) => {
    const inputValue = event.target.value;
    const getName = "Due Date";
    // Check if the input date is not empty and if it is valid
    if (inputValue.trim() !== "" && !isValidDate(inputValue)) {
      handleChanges(event, true, "Invalid " + getName + " format");
      //addToastError(setToasts, "Invalid " + getName + " format");
      // Reset the input value
      event.target.value = "";
    } else {
      handleChanges(event, true, "Please enter Due Date");
      // updateParam(event); // or whatever function you need to call when the date changes
    }
  };

  const handleAmountChange = (e) => {
    let newTotal = parseFloat(e.target.value) || 0;
    // Allow clearing the input
    if (newTotal === "" || newTotal === 0) {
      setAddParam({
        ...addParam,
        amount: "",
        cgstAmount: 0,
        sgstAmount: 0,
        igstAmount: 0,
        totalAmount: 0,
      });
      handleChanges(e, true, getAmountValidationErrors());
      return;
    }
    if (
      /^[1-9]\d*(\.\d+)?$/.test(newTotal) || // Allow numbers like 1, 1.5, 123.45
      /^0\.\d+$/.test(newTotal) // Allow numbers like 0.1, 0.25
    ) {
      //if (!newTotal || (!isNaN(Number(newTotal)) && Number(newTotal) >= 0)) {
      updateParam(e);
      let Total = "";
      if (parseInt(selectedOption) === 2) {
        //setTotal(newTotal);
        const value = isIGST
          ? calculatePercentage(newTotal, "5").toFixed(2)
          : calculatePercentage(newTotal, "2.5").toFixed(2);

        if (isIGST) {
          updateParam(e);
          Total = newTotal + value;
          setAddParam({
            ...addParam,
            amount: newTotal,
            igstAmount: value,
            totalAmount: Total,
          });
        } else {
          updateParam(e);
          Total = newTotal + value + value;
          setAddParam({
            ...addParam,
            amount: newTotal,
            cgstAmount: value,
            sgstAmount: value,
            totalAmount: Total,
          });
        }
        handleChanges(e, true, getAmountValidationErrors());
      } else if (parseInt(selectedOption) === 1) {
        handleChanges(e, true, getAmountValidationErrors());
      }
    }
  };
  const handleIGSTSGSTAmountChange = (e) => {
    let newTotal = parseFloat(e.target.value) || 0;
    if (newTotal === "" || newTotal === 0) {
      setAddParam({
        ...addParam,
        cgstAmount: "",
      });
      handleChanges(e, true, getIGSTAmountValidationErrors());
      return;
    }
    let Total = "";
    if (
      /^[1-9]\d*(\.\d+)?$/.test(newTotal) || // Allow numbers like 1, 1.5, 123.45
      /^0\.\d+$/.test(newTotal) // Allow numbers like 0.1, 0.25
    ) {
      if (parseInt(selectedOption) === 3) {
        setAddParam({
          ...addParam,
          amount: 0,
          igstAmount: addParam.sgstAmount,
          totalAmount: 0,
        });
        handleChanges(e, true, getIGSTAmountValidationErrors());
      } else if (parseInt(selectedOption) === 2) {
        Total = parseFloat(addParam.amount) + newTotal;
        setAddParam({
          ...addParam,
          amount: addParam.amount,
          igstAmount: newTotal,
          totalAmount: Total,
        });
        handleChanges(e, true, getIGSTAmountValidationErrors());
      }
    }
  };
  const handleCGSTSGSTAmountChange = (e) => {
    let newTotal = parseFloat(e.target.value) || 0;
    if (newTotal === "" || newTotal === 0) {
      if (e.target.name === "cgstAmount") {
        setAddParam({
          ...addParam,
          cgstAmount: "",
        });
        handleChanges(e, true, getCGSTAmountValidationErrors());
      } else if (e.target.name === "sgstAmount") {
        setAddParam({
          ...addParam,
          sgstAmount: "",
        });
        handleChanges(e, true, getSGSTAmountValidationErrors());
      }

      return;
    }
    let Total = "";
    if (
      /^[1-9]\d*(\.\d+)?$/.test(newTotal) || // Allow numbers like 1, 1.5, 123.45
      /^0\.\d+$/.test(newTotal) // Allow numbers like 0.1, 0.25
    ) {
      if (parseInt(selectedOption) === 3) {
        if (e.target.name === "cgstAmount") {
          Total = newTotal + parseFloat(addParam.sgstAmount);
          setAddParam({
            ...addParam,
            amount: 0,
            cgstAmount: newTotal,
            sgstAmount: addParam.sgstAmount,
            totalAmount: Total,
          });
          handleChanges(e, true, getCGSTAmountValidationErrors());
        } else if (e.target.name === "sgstAmount") {
          Total = newTotal + parseFloat(addParam.cgstAmount);
          setAddParam({
            ...addParam,
            amount: 0,
            cgstAmount: addParam.cgstAmount,
            sgstAmount: newTotal,
            totalAmount: Total,
          });
          handleChanges(e, true, getSGSTAmountValidationErrors());
        }
      } else if (parseInt(selectedOption) === 2) {
        if (e.target.name === "cgstAmount") {
          Total =
            parseFloat(addParam.amount) +
            newTotal +
            parseFloat(addParam.sgstAmount);
          console.log("cgstAmount : ", Total);
          setAddParam({
            ...addParam,
            amount: addParam.amount,
            cgstAmount: newTotal,
            sgstAmount: addParam.sgstAmount,
            totalAmount: Total,
          });
          handleChanges(e, true, getCGSTAmountValidationErrors());
        } else if (e.target.name === "sgstAmount") {
          Total =
            parseFloat(addParam.amount) +
            parseFloat(addParam.cgstAmount) +
            newTotal;

          console.log(" sgstAmount : ", Total);
          setAddParam({
            ...addParam,
            amount: addParam.amount,
            cgstAmount: addParam.cgstAmount,
            sgstAmount: newTotal,
            totalAmount: Total,
          });
          handleChanges(e, true, getSGSTAmountValidationErrors());
        }
      }
    }
  };
  const getAmountValidationErrors = () => {
    const errors = [];
    if (parseInt(selectedOption) === 1 || parseInt(selectedOption) === 2) {
      if (AmountValidationFloat(addParam.amount)) {
        errors.push("Please enter Amount. ");
      }
      if (parseFloat(addParam.amount) <= 0) {
        errors.push("Amount must be greater than zero. ");
      }
    }
    return errors;
  };
  const getIGSTAmountValidationErrors = () => {
    const errors = [];
    if (
      (parseInt(selectedOption) === 2 || parseInt(selectedOption) === 3) &&
      isIGST === true
    ) {
      if (AmountValidationFloat(addParam.igstAmount)) {
        errors.push("Please enter ISGST 5%");
      }
      // if (!addParam.cgstAmount) {
      //   errors.push("Please enter a valid number for CGST.");
      // }
      if (parseFloat(addParam.igstAmount) < 0) {
        errors.push("Amount must be greater than zero.");
      }

      if (
        !AmountValidationFloat(addParam.igstAmount) &&
        parseFloat(addParam.igstAmount) > 0 &&
        parseInt(selectedOption) === 2
      ) {
        const countigst = calculatePercentage(addParam.amount, "5");
        if (
          parseFloat(countigst).toFixed(2) !==
          parseFloat(addParam.igstAmount).toFixed(2)
        ) {
          errors.push("IGST Amount Is Wrong");
        }
      }
    }
    return errors;
  };
  const getCGSTAmountValidationErrors = () => {
    const errors = [];

    if (
      (parseInt(selectedOption) === 2 || parseInt(selectedOption) === 3) &&
      isIGST === false
    ) {
      // if (!addParam.cgstAmount) {
      //   errors.push("Please enter a valid number for CGST.");
      // }
      if (parseFloat(addParam.cgstAmount) <= 0) {
        errors.push("CGST must be greater than zero. ");
      }
      if (parseFloat(addParam.cgstAmount) !== parseFloat(addParam.sgstAmount)) {
        errors.push("CGST and SGST amounts must be equal. ");
      }
      if (
        !AmountValidationFloat(addParam.cgstAmount) &&
        parseFloat(addParam.cgstAmount) > 0 &&
        parseInt(selectedOption) !== 3
      ) {
        const countAmount = calculatePercentage(addParam.amount, "2.5").toFixed(
          2
        );
        // if (
        //   parseFloat(countAmount).toFixed(2) !==
        //   parseFloat(addParam.cgstAmount).toFixed(2)
        // ) {
        //   errors.push("CGST Amount Is Wrong.");
        // }
      }
    }
    return errors;
  };

  const getSGSTAmountValidationErrors = (e) => {
    const errors = [];
    if (
      (parseInt(selectedOption) === 2 || parseInt(selectedOption) === 3) &&
      isIGST === false
    ) {
      // if (
      //   AmountValidationFloat(addParam.sgstAmount) &&
      //   parseFloat(addParam.sgstAmount) >= 0
      // ) {
      //   errors.push("Please enter a valid number for SGST.");
      // }
      // if (!addParam.sgstAmount) {
      //   errors.push("Please enter a valid number for SGST.");
      // }
      debugger;
      if (parseFloat(addParam.sgstAmount) <= 0) {
        errors.push("SGST must be greater than zero. ");
      }
      if (parseFloat(addParam.cgstAmount) !== parseFloat(addParam.sgstAmount)) {
        errors.push("CGST and SGST amounts must be equal. ");
      }
      if (
        !AmountValidationFloat(addParam.sgstAmount) &&
        parseFloat(addParam.sgstAmount) > 0 &&
        parseInt(selectedOption) !== 3
      ) {
        const countAmount = calculatePercentage(addParam.amount, "2.5");
        console.log("countAmount : " + countAmount);
        // if (
        //   parseFloat(countAmount).toFixed(2) !==
        //   parseFloat(addParam.sgstAmount).toFixed(2)
        // ) {
        //   errors.push("SGST Amount Is Wrong.");
        // }
      }
    }
    return errors;
  };
  const getTitleOptionValidationErrors = () => {
    const getValue = addParam.title_purposes_option.trim();

    const errors = [];

    if ((!getValue && getValue.length === 0) || getValue.trim() === "") {
      errors.push("Please select Title/Purpose");
    }
    UpdateErrorArray(
      "title_purposes_option",
      errors.length > 0 ? errors : "",
      true
    );
    return errors;
  };

  const getTitleValidationErrors = () => {
    const getValue = addParam.title_purposes.trim();

    const errors = [];
    if (addParam.title_purposes_option.trim() === "Others") {
      //&&  getValue.length === 0
      if ((!getValue && getValue.length === 0) || getValue.trim() === "") {
        errors.push("Please enter Title/Purpose");
      }
      if (getValue.length > 100) {
        errors.push("Title/Purpose: Maximum 100 characters allowed.");
      }
    }
    return errors;
  };
  const getCommentValidationErrors = () => {
    const getValue = addParam.created_comment;
    const errors = [];

    if (!getValue && getValue.length === 0) {
      errors.push("Please enter Comment");
    }
    if (getValue.length > 300) {
      errors.push("Comment Maximum 300 Characters allowed.");
    }
    return errors;
  };

  const getSupportDocumentValidationErrors = () => {
    const errors = [];
    let fileEvent = DocumentFileEvent;
    if (
      !fileEvent ||
      !fileEvent.target ||
      !fileEvent.target.files ||
      (fileEvent.target.files.length === 0 &&
        usersData.supportFilePath === undefined)
    ) {
      errors.push("Please Upload Supporting Document file!");
      const geteErrors = errors.length > 0 ? errors : "";
      UpdateErrorArray("support_document", geteErrors, true);
      return errors;
    }
    if (fileEvent) {
      const file = fileEvent.target.files[0];

      if (file.type !== "application/pdf") {
        errors.push("Please Upload Only PDF file!");
      } else if (file.size > 2 * 1024 * 1024) {
        // 2MB in bytes
        errors.push("File size exceeds 2MB. Please upload a smaller file.");
      }
    }
    UpdateErrorArray("support_document", errors.length > 0 ? errors : "", true);
    return errors;
  };

  const UpdateErrorArray = (frname, errorMsg, isErrorMsgArray = false) => {
    let FromStateJson = formState[frname];
    if (isErrorMsgArray === true) {
      FromStateJson.valid = errorMsg.length > 0 ? false : true;
      FromStateJson.errors = errorMsg.length > 0 ? errorMsg : "";
    } else {
      FromStateJson.valid = errorMsg ? false : true;
      FromStateJson.errors = errorMsg ? errorMsg : "";
    }
    setFromState((prevState) => ({
      ...prevState,
      [frname]: FromStateJson,
    }));
  };
  const ValidationChecker = (e) => {
    UpdateErrorArray(
      "paymentTypeId",
      addParam.paymentTypeId === 0 || addParam.paymentTypeId === ""
        ? "Please Select Payment Option"
        : ""
    );

    UpdateErrorArray(
      "dueDate",
      addParam.dueDate === "" ? "Please enter Due Date" : ""
    );

    if (parseInt(selectedOption) === 1 || parseInt(selectedOption) === 2) {
      const errorMsgOfAmount = getAmountValidationErrors();

      UpdateErrorArray(
        "amount",
        errorMsgOfAmount.length > 0 ? errorMsgOfAmount : "",
        true
      );
    }
    if (parseInt(selectedOption) === 2 || parseInt(selectedOption) === 3) {
      if (isIGST === true) {
        const errorMsgOfIGSTAmount = getIGSTAmountValidationErrors();

        UpdateErrorArray(
          "igstAmount",
          errorMsgOfIGSTAmount.length > 0 ? errorMsgOfIGSTAmount : "",
          true
        );
      } else {
        const errorMsgOfCGSTAmount = getCGSTAmountValidationErrors();

        console.log("errorMsgOfCGSTAmount : ", errorMsgOfCGSTAmount);
        UpdateErrorArray(
          "cgstAmount",
          errorMsgOfCGSTAmount.length > 0 ? errorMsgOfCGSTAmount : "",
          true
        );
        const errorMsgOfSGSTAmount = getSGSTAmountValidationErrors();

        console.log("errorMsgOfSGSTAmount : ", errorMsgOfSGSTAmount);
        UpdateErrorArray(
          "sgstAmount",
          errorMsgOfSGSTAmount.length > 0 ? errorMsgOfSGSTAmount : "",
          true
        );
      }
    }

    const errorMsgOfTitleOption = getTitleOptionValidationErrors();

    UpdateErrorArray(
      "title_purposes_option",
      errorMsgOfTitleOption.length > 0 ? errorMsgOfTitleOption : "",
      true
    );

    const errorMsgOfTitle = getTitleValidationErrors();

    UpdateErrorArray(
      "title_purposes",
      errorMsgOfTitle.length > 0 ? errorMsgOfTitle : "",
      true
    );

    const errorMsgOfComment = getCommentValidationErrors();

    UpdateErrorArray(
      "created_comment",
      errorMsgOfComment.length > 0 ? errorMsgOfComment : "",
      true
    );
    if (
      usersData.supportFilePath === null ||
      usersData.supportFilePath === "" ||
      usersData.supportFilePath === undefined
    ) {
      const errorMsgOfSupportDocument = getSupportDocumentValidationErrors();
      UpdateErrorArray(
        "support_document",
        errorMsgOfSupportDocument.length > 0 ? errorMsgOfSupportDocument : "",
        true
      );
    } else {
      let FromStateJson = formState["support_document"];
      FromStateJson.valid = true;
      FromStateJson.errors = "";

      setFromState((prevState) => ({
        ...prevState,
        ["support_document"]: FromStateJson,
      }));
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    if (authenticated) {
      console.log("addParam : ", addParam);
      ValidationChecker(e);

      e.preventDefault();
      console.log("formState : ", formState);
      const isValid = Object.values(formState).every((field) => field.valid);
      console.log("form isValid : ", isValid);
      if (isValid) {
        let data = {
          //   tender_id: Number(search.tenderId),

          adHoc_payment_id: Number(decrypted),
          payment_type_id: Number(addParam.paymentTypeId),
          due_date: addParam.dueDate,
          amount: Number(
            addParam.amount ? parseFloat(addParam.amount).toFixed(2) : 0.0
          ),
          cgst_amount: Number(
            addParam.cgstAmount
              ? parseFloat(addParam.cgstAmount).toFixed(2)
              : "0.00"
          ),
          sgst_amount: Number(
            addParam.sgstAmount
              ? parseFloat(addParam.sgstAmount).toFixed(2)
              : "0.00"
          ),
          igst_amount: Number(
            addParam.igstAmount
              ? parseFloat(addParam.igstAmount).toFixed(2)
              : "0.00"
          ),
          title_purpose: addParam.title_purposes,
          inserted_comment: addParam.created_comment,
          inserted_by: authenticated.userId,
        };
        console.log(data);

        console.log("deee data", data);

        // let file = DocumentSelectedFile;
        // let filename = "";
        // if (file !== null && file !== undefined) {
        //   filename = file.name;
        // }

        let fileEvent = DocumentFileEvent;
        if (
          fileEvent !== false &&
          fileEvent.target.files[0].type !== "application/pdf"
        ) {
          addToastError(setToasts, "Please Upload Only pdf file!");
          //setSubmitted(true);
          setSubmitLoading(false);
          return;
        } else {
          let url = "LotAdHocPayment/UpdateByMaker";

          await apiCallSPPost(url, JSON.stringify(data), 0)
            .then(async (res) => {
              if (res.success) {
                if (DocumentFileEvent !== false) {
                  await SaveReverseDoc(Number(decrypted));
                } else {
                  addToastSuccess(setToasts, res.message);
                  //alert("Data Submited Successfully");
                  history.push(`/lot/adhocpayment`, {
                    from: window.location.href,
                  });
                }
              } else {
                addToastError(setToasts, res.message);
              }
            })
            .finally(() => {
              //setloading(false);
              //setSubmitted(true);
              setSubmitLoading(false);
            });
        }
        // Your API call logic here
      } else {
        //setSubmitted(true);
        setSubmitLoading(false);
        console.log("Form is invalid. Cannot submit.");
        console.log("formState : ", formState);
      }
    }
  };
  const SaveReverseDoc = async (Id) => {
    let fileEvent = DocumentFileEvent;
    let file = DocumentSelectedFile;
    if (fileEvent !== false) {
      if (authenticated) {
        if (fileEvent.target.files[0].type === "application/pdf") {
          // setSelectedFile(e.target.files[0]);
          //const files = fileEvent.target.files[0];
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");

          formData.append("file", file);

          const url = `LotAdHocPayment/UploadSupportDocument/${Id}`;

          await apiCallResponsePost(url, header, formData).then((res) => {
            if (res.success) {
              setDocumentSelectedFile();
              setDocumentFileEvent(false);
              //alert("Data Submited Successfully");
              addToastSuccess(setToasts, res.message);
              history.push(`/lot/adhocpayment`, {
                from: window.location.href,
              });
            } else {
              addToastError(setToasts, "Error to upload file!");
              console.error(res.message);
              //alert();
            }
          });
        } else {
          addToastError(setToasts, "Please Upload Only pdf file!");
        }
      }
    }
  };

  const onResetData = () => {
    setSelectedOption(0);
    setAddParam({
      ...addParam, // Retain existing properties
      amount: 0, // Reset specific fields
      paymentTypeId: 0,
      dueDate: "",
      cgstAmount: 0,
      sgstAmount: 0,
      igstAmount: 0,
      title_purposes_option: "",
      title_purposes: "",
      created_comment: "",
      totalAmount: 0,
    });
    setDocumentSelectedFile();
    setDocumentFileEvent(false);
    setFromState({
      amount: { errors: "", valid: true },
      paymentTypeId: { errors: "", valid: true },
      dueDate: { errors: "", valid: true },
      cgstAmount: { errors: "", valid: true },
      sgstAmount: { errors: "", valid: true },
      igstAmount: { errors: "", valid: true },
      title_purposes_option: { errors: "", valid: true },
      title_purposes: { errors: "", valid: true },
      created_comment: { errors: "", valid: true },
      support_document: { errors: "", valid: true },
    });
  };
  const onReset = () => {
    onResetData();
    //    window.location.reload();
  };

  const deleteDocument = async () => {
    //setloadingForUpload(true);
    //const formData = new FormData();
    const header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Accept", "application/json");

    const url = "LotAdHocPayment/deleteDocument";
    const data = JSON.stringify({
      id: Number(decrypted),
    });
    await apiCallResponse(url, "PUT", header, data).then((res) => {
      console.log("wwww", res);
      if (res.success) {
        let documents = usersData;
        if (documents !== undefined && documents !== null) {
          usersData.supportFilePath = "";
          setUsersData(usersData);
          console.log(usersData);
          addToastSuccess(setToasts, res.data.message);
        }
      } else {
        addToastError(setToasts, res.data.message);
      }
    });
  };
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      {loading ? (
        <CommanPageLoader title={"Adjustment Payment - Edit"} />
      ) : (
        <>
          {usersData && (
            <div className="view">
              <DetailSectionBind
                header={"Adjustment Payment - Edit"}
                className={"mb-2"}
              />
              <DetailSectionBind
                className={"mb-2"}
                title={"Lot Detail"}
                body={LotDetail}
              />

              <DetailSectionBind
                className={"mt-1"}
                title={"Bidder Detail"}
                body={<>{BidderDetails}</>}
              />
              <hr />
              <DetailSectionBind
                className={"mt-1"}
                body={
                  <>
                    <DetailLabelBind
                      lable="Checker Date"
                      value={addParam.checker_date}
                    />
                    <DetailLabelBind
                      lable="Checker Name"
                      value={addParam.checker_by_name}
                    />

                    <DetailLabelBind
                      lable="Checker Comment"
                      value={addParam.checker_comment}
                    />
                  </>
                }
              />

              <hr />
              <DetailSectionBind
                className={"mt-1"}
                body={
                  <div className="col-12">
                    <CForm
                      onSubmit={submitHandler}
                      noValidate
                      // validated={validated}
                      // className="was-validation"
                    >
                      <DetailRowOnly
                        className={"mb-2 "}
                        header={""}
                        body={
                          <>
                            <DetailLabel lable="Payment Option" />
                            <div className="col-xs-12">
                              <div className="row">
                                <DetailChecbox
                                  label="Payment Collected without GST"
                                  name="paymentTypeId"
                                  value="1"
                                  onChange={handlePaymentChange}
                                  selectedOption={selectedOption}
                                  // required
                                />

                                <DetailChecbox
                                  label="Payment Collected  with GST"
                                  name="paymentTypeId"
                                  value="2"
                                  onChange={handlePaymentChange}
                                  selectedOption={selectedOption}
                                  // required
                                />
                                <DetailChecbox
                                  label="Only Collected GST"
                                  name="paymentTypeId"
                                  value="3"
                                  onChange={handlePaymentChange}
                                  selectedOption={selectedOption}
                                  // required
                                />
                              </div>
                              <CFormText className="error-block">
                                {formState.paymentTypeId.errors}
                              </CFormText>
                            </div>
                          </>
                        }
                      />

                      <DetailRow
                        className={"mb-2 col-xs-12"}
                        header={""}
                        body={
                          <>
                            <ControlInputValidationText
                              isRequired="true"
                              label="Due Date"
                              type="date"
                              id="dueDate"
                              name="dueDate"
                              onChange={handleDateValidation}
                              onBlur={handleDateValidation} // Add onBlur event handler
                              className={
                                "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12"
                              }
                              //invalid={submitted && !formState.dueDate.valid}
                              errorMessage={formState.dueDate.errors}
                              min={
                                new Date(Date.now() + 86400000)
                                  .toISOString()
                                  .split("T")[0]
                              }
                              value={addParam.dueDate}
                            />
                            {(selectedOption === "1" ||
                              selectedOption === "2") && (
                              <ControlInputValidationText
                                isRequired="true"
                                type="number"
                                //type="text"
                                id="amount"
                                label="Amount"
                                name="amount"
                                className={
                                  "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12"
                                }
                                min={1}
                                onChange={(e) => handleAmountChange(e)}
                                onBlur={(e) => (e) => handleAmountChange(e)}
                                errorMessage={formState.amount.errors}
                                value={addParam.amount}
                                step="0.01"
                              />
                            )}
                            {(selectedOption === "2" ||
                              selectedOption === "3") &&
                              (isIGST ? (
                                <ControlInputValidationText
                                  isRequired="true"
                                  type="number"
                                  id="igstAmount"
                                  label="IGST (5%)"
                                  name="igstAmount"
                                  className={
                                    "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12"
                                  }
                                  min={1}
                                  onChange={handleIGSTSGSTAmountChange}
                                  onBlur={handleIGSTSGSTAmountChange}
                                  // invalid={
                                  //   submitted &&
                                  //   getIGSTAmountValidationErrors().length > 0
                                  // }
                                  errorMessage={formState.igstAmount.errors}
                                  value={addParam.igstAmount}
                                />
                              ) : (
                                <>
                                  {" "}
                                  <ControlInputValidationText
                                    isRequired={true}
                                    type="number"
                                    id="cgstAmount"
                                    label="CGST "
                                    name="cgstAmount"
                                    className="col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12"
                                    min={1}
                                    onChange={handleCGSTSGSTAmountChange}
                                    onBlur={handleCGSTSGSTAmountChange}
                                    value={addParam.cgstAmount}
                                    step="0.01"
                                    //   invalid={
                                    //     submitted &&
                                    //     getCgstValidationErrors().length > 0
                                    //   }
                                    errorMessage={formState.cgstAmount.errors}
                                  />
                                  <ControlInputValidationText
                                    isRequired="true"
                                    type="number"
                                    id="sgstAmount"
                                    label="SGST"
                                    name="sgstAmount"
                                    className={
                                      "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12"
                                    }
                                    min={1}
                                    onChange={handleCGSTSGSTAmountChange}
                                    onBlur={handleCGSTSGSTAmountChange}
                                    value={addParam.sgstAmount}
                                    step="0.01"
                                    //   invalid={
                                    //     submitted &&
                                    //     getSgstValidationErrors().length > 0
                                    //   }
                                    errorMessage={formState.sgstAmount.errors}
                                  />
                                </>
                              ))}
                            {(selectedOption === "2" ||
                              (selectedOption === "3" && isIGST === false)) && (
                              <ControlInputValidationText
                                isRequired="false"
                                type="number"
                                id="totalAmount"
                                label="Total"
                                name="totalAmount"
                                className={
                                  "col-xxl-3 col-xl-4 col-md-4 col-sm-6 col-xs-12"
                                }
                                min={0}
                                onChange={updateParam}
                                value={addParam.totalAmount}
                                disabled={true}
                              />
                            )}

                            <ControlFileUpload
                              isRequired={true}
                              label={
                                <>
                                  Supporting Document{" - "}
                                  <AnchorLinkSet
                                    ButtonName={"View"}
                                    filepath={`Documents/AdHocPayment/${usersData.lotId}`}
                                    fileName={valueSet(
                                      usersData?.supportFilePath
                                    )}
                                  />
                                  {valueSet(usersData?.supportFilePath) && (
                                    <CButton
                                      color="link"
                                      size="sm"
                                      shape="rounded-pill"
                                      className="ml-2"
                                      onClick={() => deleteDocument()}
                                    >
                                      Delete
                                    </CButton>
                                  )}
                                </>
                              }
                              name="supportDocument"
                              id="supportDocument"
                              className="col-xxl-3 col-xl-4 col-md-6 col-sm-6 col-xs-12 "
                              selectedFile={DocumentSelectedFile}
                              onChange={(e) =>
                                handleChangeSupportingDocument(e)
                              }
                              errorMessage={formState.support_document.errors}
                              displayUploadController={
                                valueSet(usersData?.supportFilePath) !== ""
                                  ? false
                                  : true
                              }
                            />
                            <ControlSelectValidation
                              isRequired="true"
                              id="title_purposes_option"
                              label="Title / Purpose"
                              name="title_purposes_option"
                              value={addParam.title_purposes_option}
                              onChange={handleChangeTitlePurposesOption}
                              items={TitlePurposesOption}
                              errorMessage={
                                formState.title_purposes_option.errors
                              }
                            />
                            {addParam.title_purposes_option === "Others" && (
                              <ControlInputValidationText
                                isRequired="true"
                                type="text"
                                id="title_purposes"
                                label="Title / Purpose - Others"
                                name="title_purposes"
                                className={
                                  "col-xxl-6 col-xl-6 col-md-6 col-sm-6 col-xs-12"
                                }
                                min={0}
                                max={100}
                                onChange={(e) =>
                                  handleChanges(
                                    e,
                                    true,
                                    getTitleValidationErrors()
                                  )
                                }
                                onBlur={(e) =>
                                  handleChanges(
                                    e,
                                    true,
                                    getTitleValidationErrors()
                                  )
                                }
                                value={addParam.title_purposes}
                                errorMessage={formState.title_purposes.errors}
                              />
                            )}
                            <ControlTextAreaValidationText
                              isRequired="true"
                              type="text"
                              id="created_comment"
                              label="Comment"
                              name="created_comment"
                              className={
                                "col-xxl-6 col-xl-6 col-md-6 col-sm-6 col-xs-12"
                              }
                              inputclassName={"col-xs-12"}
                              min={0}
                              max={300}
                              onChange={(e) =>
                                handleChanges(
                                  e,
                                  true,
                                  getCommentValidationErrors()
                                )
                              }
                              // invalid={
                              //   submitted && !formState.created_comment.valid
                              // }
                              value={addParam.created_comment}
                              errorMessage={formState.created_comment.errors}
                              //errorMessage="Please enter Comment"
                            />
                          </>
                        }
                      />

                      <div className="mb-3 row">
                        <div className="col-xl-5">
                          <CButton
                            className=""
                            disabled={submitLoading}
                            type="submit"
                            //type="button"
                            color="success"
                            //onClick={(e) => submitHandler(e)}
                          >
                            Update
                          </CButton>
                          <CButton
                            className="ml-3"
                            //type="reset"
                            color="danger"
                            onClick={onReset}
                          >
                            Cancel
                          </CButton>
                          <CButton
                            type="button"
                            className="ml-3"
                            color="dark"
                            onClick={() => history.goBack()}
                          >
                            Go Back
                          </CButton>
                        </div>
                      </div>
                    </CForm>
                  </div>
                }
              />
              {/* <div className="row">
                <div className={"mt-2 mb-2 col-xl-6 col-sm-5"}></div>
              </div> */}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AdHocPaymentEdit;
